export default __webpack_public_path__ + "static/media/1 (2000).e8bbb256.jpg";